// import * as lazysizes from 'lazysizes';
// import 'lazysizes/plugins/respimg/ls.respimg';
// import 'lazysizes/plugins/parent-fit/ls.parent-fit';
// import 'lazysizes/plugins/object-fit/ls.object-fit';
/**
 * 
        __
       /\  \    
      |::\  \   
      |:|:\  \  
    __|:|\:\  \ 
   /::::|_\:\__\
   \:\~~\  \/__/
    \:\  \      
     \:\  \     
      \:\__\    
       \/__/    

M

Tiny ES6 module template for progressive enhancement.



import M from '@superstructure.net/m';

export default class MyModule extends M {
    constructor(mediaQuery) {
        super(mediaQuery);
    }

    onInit() {}

    onResize(viewport, isUIResize) {} 

    onDestroy() {}
} 

 *
 * 
 */ class $e837b47eaf942348$export$2e2bcd8739ae039 {
    constructor(mediaQuery = "screen"){
        this._name = this.constructor.name.toLowerCase();
        this._mediaQuery = mediaQuery;
        this._mediaQueryList = window.matchMedia(mediaQuery);
        this._resizeDelay = 500;
        this._resizeDebounce = null;
        this._runResizeHook = false;
        this._viewport = {
            prevWidth: undefined,
            prevHeight: undefined,
            width: undefined,
            height: undefined
        };
        this._initiated = false;
        this._onResize();
        this._onMediaQueryChange();
        this._bindEvents();
    }
    selector(role) {
        if (!role) return;
        return "[data-" + this._name + '-role~="' + role + '"]';
    }
    /**
   * Internal functions
   */ _init() {
        this._initiated = true;
        document.documentElement.classList.add("initiated--" + this._name);
        if (this.onInit) this.onInit();
    }
    _destroy() {
        if (this.onDestroy) this.onDestroy();
        document.documentElement.classList.remove("initiated--" + this._name);
        this._initiated = false;
    }
    _bindEvents() {
        /**
     * MediaQueryList listener
     */ if (this._mediaQueryList.addEventListener) this._mediaQueryList.addEventListener("change", ()=>{
            this._handleMediaQueryChange();
        });
        else if (this._mediaQueryList.addListener) this._mediaQueryList.addListener(()=>{
            this._handleMediaQueryChange();
        });
        /**
     * Resize event
     */ window.addEventListener("resize", ()=>{
            this._handleResize();
        });
    }
    _handleMediaQueryChange() {
        this._runResizeHook = false;
        this._onMediaQueryChange();
    }
    _handleResize() {
        clearTimeout(this._resizeDebounce);
        this._resizeDebounce = setTimeout(()=>{
            this._onResize();
        }, this._resizeDelay);
    }
    _onMediaQueryChange() {
        if (this._mediaQueryList.matches) {
            if (!this._initiated) this._init();
        } else if (this._initiated) this._destroy();
    }
    _onResize() {
        this._viewport.prevWidth = this._viewport.width || window.innerWidth;
        this._viewport.prevHeight = this._viewport.height || window.innerHeight;
        this._viewport.width = window.innerWidth;
        this._viewport.height = window.innerHeight;
        // calculate 100vh
        const _div = document.createElement("div");
        _div.style.height = "100vh";
        document.body.appendChild(_div);
        this._viewport.height100vh = _div.clientHeight;
        document.body.removeChild(_div);
        if (this._runResizeHook && this._initiated && this.onResize) this.onResize(this._viewport, this._viewport.width < 840 && this._viewport.width === this._viewport.prevWidth && Math.abs(this._viewport.height - this._viewport.prevHeight) < 120);
        this._runResizeHook = true;
    }
}


/**
 * 
     _|_|_|  
   _|        
   _|        
   _|        
     _|_|_| 

C

Tiny event helper with a familiar fluent API.

 * 
 */ class $96656d781e001735$export$2e2bcd8739ae039 {
    constructor(root = document){
        this.root = root;
        this.events = [];
    }
    on(type, selector = document, handler = ()=>{}, options = {}, once = false) {
        if (!type) return this;
        let _event = {};
        _event["type"] = type;
        _event["selector"] = selector;
        _event["options"] = options;
        _event["once"] = once;
        _event["originalHandler"] = handler;
        _event["handler"] = ()=>{
            // if no selector or selector is root element,
            // directly call handler
            if (!selector || selector === document || selector === window) {
                handler.call(this, event);
                if (once) this.off(type, selector, _event["originalHandler"], options);
            // if selector is present and event is not bubbled up o the root
            } else if (event.target !== document) {
                // target === selector
                if (event.target.matches(selector)) {
                    handler.call(this, event);
                    if (once) this.off(type, selector, _event["originalHandler"], options);
                // target is child of selector AND we are not in the capture phase
                } else if (event.target.closest && event.target.closest(selector) && !options.capture) {
                    event.actualTarget = event.target.closest(selector);
                    handler.call(this, event);
                    if (once) this.off(type, selector, _event["originalHandler"], options);
                }
            }
        };
        _event["handler"].bind(this);
        this.root.addEventListener(type, _event["handler"], options);
        this.events.push(_event);
        return this;
    }
    once(type, selector = document, handler = ()=>{}, options = {}) {
        this.on(type, selector, handler, options, true);
    }
    off(type, selector = null, handler = null, options = null) {
        // why while?
        // https://stackoverflow.com/a/24813338/2799523
        let index = this.events.length - 1;
        while(index >= 0){
            let event1 = this.events[index];
            /*
            console.log('comparing type', event['type'], type, !type || event['type'] == type);
            console.log('comparing selector', event['selector'], selector, !selector || event['selector'] == selector);
            console.log(
                'comparing handler',
                event['originalHandler'],
                handler,
                !handler || event['originalHandler'] == handler
            );
            console.log(
                'comparing options',
                event['options'],
                options,
                !options || JSON.stringify(event['options']) == JSON.stringify(options)
            );
            */ if ((!type || event1["type"] === type) && (!selector || event1["selector"] === selector) && (!handler || event1["originalHandler"] === handler) && (!options || JSON.stringify(event1["options"]) === JSON.stringify(options))) {
                this.root.removeEventListener(event1["type"], event1["handler"], event1["options"]);
                this.events.splice(index, 1);
            }
            index--;
        }
        return this;
    }
    trigger(type, data = {}, element = this.root) {
        if (!type) return this;
        element.dispatchEvent(new CustomEvent(type, {
            bubbles: true,
            detail: data
        }));
        return this;
    }
}


/**
 * Video
 */ class $13123c0d4e7e5ea4$export$ae01dedf5c052bb extends (0, $e837b47eaf942348$export$2e2bcd8739ae039) {
    constructor(mediaQuery){
        super(mediaQuery);
    }
    bindEvents() {
        this.video.addEventListener("canplay", ()=>{
            console.log("video", this.video);
            this.video.play().then(()=>{}).catch(()=>{});
        });
    }
    onInit() {
        console.log("Video.onInit()");
        this.events = new (0, $96656d781e001735$export$2e2bcd8739ae039)();
        this.video = document.querySelector('[data-Video-role~="video"]');
        this.wrapper = document.querySelector('[data-Video-role~="wrapper"]');
        if (!this.video || !this.wrapper) return;
        this.bindEvents();
    }
    onResize(viewport, isUIResize) {
        console.log("Video.onResize()");
    }
    onDestroy() {
        console.log("Video.onDestroy()");
        this.events.off();
    }
}


new (0, $13123c0d4e7e5ea4$export$ae01dedf5c052bb)();


//# sourceMappingURL=index.ac0b0b01.js.map
